// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"221":"b5722e27","855":"b5722e27"}[chunkId] + ".chunk.css";
};